class MoCartGift extends HTMLElement {
  static pending = false;
  static locked = false;

  static lockCheckout(locked) {
    MoCartGift.locked = locked;
    document.querySelectorAll('[data-mo-gift-checkout]').forEach(group => { group.disabled = locked; });
  }

  connectedCallback() {
    if (this.connected) return;
    this.connected = true;
    this.addEventListener('click', event => {
      if (event.target.closest('[data-mo-gift-retry]')) {
        this.cleanUp();
        return;
      }
      const button = event.target.closest('[data-mo-choice]');
      if (button) this.choose(button);
    });
    if (this.dataset.legacyKeys || this.dataset.staleChoice === 'true') {
      MoCartGift.lockCheckout(true);
      this.cleanUp();
    } else if (!MoCartGift.pending) {
      const invalidGift = [...document.querySelectorAll('mo-cart-gift')].some(gift => gift.dataset.legacyKeys || gift.dataset.staleChoice === 'true');
      if (!invalidGift) MoCartGift.lockCheckout(false);
    }
  }

  async request(body) {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    });
    const state = await response.json();
    if (!response.ok || state.errors || !state.sections?.['cart-drawer']) throw new Error('cart');
    return state;
  }

  inspect(state) {
    const fragment = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
    const gift = fragment.querySelector('mo-cart-gift[data-mo-gift-state="1"]');
    if (!gift) throw new Error('cart');
    return {
      legacyKeys: (gift.dataset.legacyKeys || '').split(',').filter(Boolean),
      staleChoice: gift.dataset.staleChoice === 'true',
    };
  }

  async normalise(state) {
    let removed = false;
    for (let attempt = 0; attempt < 2; attempt++) {
      const current = this.inspect(state);
      if (!current.staleChoice && current.legacyKeys.length === 0) return { state, removed };
      const body = { attributes: { Gratisbeigabe: current.staleChoice ? '' : state.attributes?.Gratisbeigabe || '' } };
      if (current.legacyKeys.length) body.updates = Object.fromEntries(current.legacyKeys.map(key => [key, 0]));
      removed = removed || current.staleChoice;
      state = await this.request(body);
    }
    const current = this.inspect(state);
    if (current.staleChoice || current.legacyKeys.length) throw new Error('cart');
    return { state, removed };
  }

  render(state, message) {
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) { location.reload(); return; }
    const drawer = document.querySelector('cart-drawer');
    drawer.renderContents(state);
    if (message) {
      const status = drawer.querySelector('.mo-choice__error');
      if (status) status.textContent = message;
    }
  }

  showError() {
    document.querySelectorAll('mo-cart-gift').forEach(gift => {
      gift.querySelector('.mo-choice__error').textContent = gift.dataset.error;
      const retry = gift.querySelector('[data-mo-gift-retry]');
      retry.hidden = false;
      retry.disabled = false;
      gift.querySelectorAll('[data-mo-choice]').forEach(button => { button.disabled = true; });
    });
  }

  async run(action) {
    if (MoCartGift.pending) return;
    MoCartGift.pending = true;
    MoCartGift.lockCheckout(true);
    this.setAttribute('aria-busy', 'true');
    this.querySelectorAll('button').forEach(button => { button.disabled = true; });
    let result;
    try {
      result = await this.normalise(await action());
    } catch {
      this.showError();
    } finally {
      MoCartGift.pending = false;
      this.removeAttribute('aria-busy');
      this.querySelector('[data-mo-gift-retry]').disabled = false;
    }
    if (!result) return;
    MoCartGift.lockCheckout(false);
    this.render(result.state, result.removed ? this.dataset.removed : '');
  }

  async choose(button) {
    if (MoCartGift.pending || MoCartGift.locked || this.dataset.eligible !== 'true' || button.disabled) return;
    const choices = ['2 Motivpostkarten', '1 × Charakterkarte', '1 × Charms-Anhänger'];
    if (!choices.includes(button.dataset.moChoice)) return;
    await this.run(async () => {
      const state = await this.request({ attributes: { Gratisbeigabe: button.dataset.moChoice } });
      if (state.attributes?.Gratisbeigabe !== button.dataset.moChoice) throw new Error('attribute');
      return state;
    });
  }

  async cleanUp() {
    await this.run(async () => {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      const legacyKeys = cart.items.filter(item => item.properties?._mo_goodie === '1').map(item => item.key);
      const body = { attributes: { Gratisbeigabe: cart.attributes?.Gratisbeigabe || '' } };
      if (legacyKeys.length) body.updates = Object.fromEntries(legacyKeys.map(key => [key, 0]));
      return this.request(body);
    });
  }
}
if (!customElements.get('mo-cart-gift')) customElements.define('mo-cart-gift', MoCartGift);

